var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.268 7.20697L11.1155 2.60931C11.044 2.56901 10.956 2.56901 10.8845 2.60931L2.73205 7.20697C2.6606 7.24727 2.61658 7.32174 2.61658 7.40233V16.5977C2.61658 16.6783 2.6606 16.7527 2.73205 16.793L10.8845 21.3907C10.956 21.431 11.044 21.431 11.1155 21.3907L19.268 16.793C19.3394 16.7527 19.3834 16.6783 19.3834 16.5977V7.40233C19.3834 7.32174 19.3394 7.24727 19.268 7.20697ZM11.9238 1.24178C11.3521 0.919407 10.6479 0.919407 10.0762 1.24178L1.92376 5.83945C1.35214 6.16182 1 6.75759 1 7.40233V16.5977C1 17.2424 1.35214 17.8382 1.92376 18.1606L10.0762 22.7582C10.6479 23.0806 11.3521 23.0806 11.9238 22.7582L20.0762 18.1606C20.6479 17.8382 21 17.2424 21 16.5977V7.40233C21 6.75759 20.6479 6.16182 20.0762 5.83945L11.9238 1.24178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1855 5.79428L11.9073 1.12408C11.3458 0.80735 10.6542 0.80735 10.0927 1.12408L1.81453 5.79428C1.25311 6.11101 0.907265 6.69634 0.907265 7.3298V16.6702C0.907265 17.3037 1.25311 17.889 1.81453 18.2057L10.0927 22.8759C10.6542 23.1926 11.3458 23.1926 11.9073 22.8759L20.1855 18.2057C20.7469 17.889 21.0927 17.3037 21.0927 16.6702V7.3298C21.0927 6.69634 20.7469 6.11101 20.1855 5.79428ZM12.3609 0.356318C11.5188 -0.118773 10.4812 -0.118773 9.6391 0.356318L1.3609 5.02652C0.518771 5.50161 0 6.37962 0 7.3298V16.6702C0 17.6204 0.518771 18.4984 1.3609 18.9735L9.6391 23.6437C10.4812 24.1188 11.5188 24.1188 12.3609 23.6437L20.6391 18.9735C21.4812 18.4984 22 17.6204 22 16.6702V7.3298C22 6.37962 21.4812 5.50161 20.6391 5.02652L12.3609 0.356318Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGame2);
export default __webpack_public_path__ + "static/media/game-2.cb4694491f66646b625cc2f11dbcce7f.svg";
export { ForwardRef as ReactComponent };